import { useState } from "react";
import { Music } from "lucide-react";
import { useBrandingAssets } from "@/hooks/useBrandingAssets";

interface BrandLogoMarkProps {
  className?: string;
  // Shape/size for the fallback mark, when it differs from `className`
  // (e.g. a non-square img like `w-auto` needs a fixed-width fallback box).
  fallbackClassName?: string;
  iconSize?: number;
}

// Renders the configured site logo, falling back to a drawn mark (never
// fetched, so it can't itself fail to load) if the logo image errors out.
export function BrandLogoMark({
  className = "h-6 w-6 rounded-md object-cover",
  fallbackClassName,
  iconSize = 14,
}: BrandLogoMarkProps) {
  const { logoUrl } = useBrandingAssets();
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <span
        className={`${fallbackClassName ?? className} shrink-0 bg-[#5A31D8] flex items-center justify-center`}
      >
        <Music size={iconSize} className="text-white" strokeWidth={2} />
      </span>
    );
  }

  return (
    <img
      src={logoUrl}
      alt="PayStreem"
      className={`${className} shrink-0`}
      onError={() => setFailed(true)}
    />
  );
}
